import script from "./configSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./configSettings.vue?vue&type=script&setup=true&lang=js"

import "./configSettings.vue?vue&type=style&index=0&id=9efefaae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9efefaae"]])

export default __exports__